import { GeoIdName } from "../types/SearchFilter";

/** One area a service listing covers. Mirrors backend CoverageAreaDTO. */
export interface CoverageArea {
    level: GeoIdName;
    id: number;
    name: string;
}

/**
 * Canonical coverage key — MUST stay byte-identical to the backend
 * CoverageKey.of(level, id) (`<GeoIdName>:<id>`, e.g. "Admin1:88"), or the
 * coverage `$in` match returns nothing.
 */
export function coverageKey(level: GeoIdName, id: number): string {
    return `${level}:${id}`;
}

/** A selected geo chain (top→deepest) → the coverage keys sent as coverageChain. */
export function chainToKeys(chain: CoverageArea[]): string[] {
    return chain.map((a) => coverageKey(a.level, a.id));
}

/** Human label for one covered area, rolled up by level. */
export function areaLabel(a: CoverageArea): string {
    switch (a.level) {
        case "Country": return `${a.name} (nationwide)`;
        case "Admin1": return `${a.name} (statewide)`;
        case "Admin2": return `${a.name} (county)`;
        default: return a.name;
    }
}

/** Compact rolled-up summary for the results column. */
export function coverageSummary(coverage: CoverageArea[] | undefined): string {
    if (!coverage || coverage.length === 0) return "";
    const parts = coverage.map(areaLabel);
    if (parts.length <= 2) return parts.join(", ");
    return `${parts.slice(0, 2).join(", ")} +${parts.length - 2}`;
}
